import React from "react";
import { useImagesModalStore } from "./ImagesModalStore";
import { ModalConstructor } from "../ModalConstructor";
import { Box, Stack, Typography } from "@mui/material";
import Masonry from "react-responsive-masonry";
import { useImagesWithInfiniteScroll } from "../../MediaListSwiper/useImagesWithInfiniteScroll";
import { PostDetailsActionType } from "../PostDetailsModal/PostDetailsModalStore";
import { PostDetailsPageActions } from "../PostDetailsModal/PostDetailsModal";
import { MODAL_TITLE_STYLES } from "../../../../styles";
import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";

export function ImagesModal({
    onPostCardClick,
    sortCriteria,
}: {
    onPostCardClick: (postId: string, action?: PostDetailsActionType) => void;
    sortCriteria?: RequestCriteriaType;
}) {
    const { isImagesModalOpen, setIsImagesModalOpen } = useImagesModalStore();
    const handleClose = () => {
        setIsImagesModalOpen(false);
    };

    const { mediaList, infiniteRef, rootRef } = useImagesWithInfiniteScroll({
        sortCriteria,
    });

    return (
        <ModalConstructor
            onClose={handleClose}
            open={isImagesModalOpen}
            scrollableContainerRef={rootRef}
            modalTitle={<Typography>Community Snapshots</Typography>}
            modalContent={
                <Stack
                    style={{
                        padding: "0 12px 12px 12px",
                    }}
                >
                    <Masonry
                        columnsCount={3}
                        style={{
                            gap: "8px",
                        }}
                    >
                        {mediaList.map((image, key) => {
                            let desiredAction: PostDetailsActionType;

                            if (image.commentId) {
                                desiredAction = {
                                    desiredAction:
                                        PostDetailsPageActions.PIN_COMMENT,
                                    commentId: image.commentId.toString(),
                                };
                            }

                            return (
                                <img
                                    key={key}
                                    onClick={(e) => {
                                        onPostCardClick(
                                            image.postId.toString(),
                                            desiredAction,
                                        );
                                    }}
                                    style={{
                                        objectFit: "cover",
                                        borderRadius: "4px",
                                        margin: "4px 0",
                                    }}
                                    src={image.imageUrl}
                                />
                            );
                        })}
                    </Masonry>
                    <Box ref={infiniteRef} height={"10px"} />
                </Stack>
            }
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={true}
            showModalActionsDivider={false}
            modalInnerContainerStyles={{
                overflowY: "unset",
                height: "calc(100vh - 24px)",
                maxWidth: "640px",
                "@media (min-width: 640px)": {
                    maxWidth: "640px",
                    borderRadius: "12px",
                },
                "& .MuiDialogContent-root": {
                    padding: "0",
                },
                "& .MuiDialogActions-root": {
                    justifyContent: "flex-start",
                    "& > :not(:first-of-type)": {
                        marginLeft: 0,
                    },
                },
                "& .MuiDialogTitle-root": {
                    margin: 0,
                    ...MODAL_TITLE_STYLES,
                    borderBottom: "none",
                    "p:first-of-type": { ...MODAL_TITLE_STYLES },
                    padding: "12px",
                },
            }}
        />
    );
}
